import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useState } from 'react'
import SubtractIcon from '~/assets/icons/callStaff/SubtractIcon'
import PlusIcon from '~/assets/icons/callStaff/PlusIcon'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { ThemeContext } from '~/theme/ThemeProvider'
import { THEMES_NAME } from '~/theme/constants'
import { DEFAULT_QUANTITY } from '~/constants/home'
import classNames from 'classnames/bind'
import styles from '../styles/CallStaffItem.module.scss'
import useIsTablet from '~/hooks/useIsTablet'

const cx = classNames.bind(styles)

export const CallStaffItem = ({ selectedItems, itemCallStaff, onSetSelectedItem }) => {
  const isTablet = useIsTablet()
  const { currentThemeObject } = useContext(ThemeContext)
  const [quantity, setQuantity] = useState(DEFAULT_QUANTITY)

  const getColorIconCallStaff = (value) => {
    return currentThemeObject.value === THEMES_NAME.red_bean ||
      currentThemeObject.value === THEMES_NAME.mangosteen
      ? value.replace('black', 'white')
      : value
  }

  const onGetColorTitle = () => {
    return currentThemeObject.value === THEMES_NAME.red_bean ||
      currentThemeObject.value === THEMES_NAME.mangosteen
      ? '#FFFFFF'
      : '#000000'
  }

  // Hàm kiểm tra xem call staff được chọn hay không
  const checkItem = (value) => {
    if (selectedItems) {
      const checkItem = selectedItems.includes(value)
      return checkItem
    }
  }

  const checkError = (isAdded, max_quantity) => {
    return quantity >= max_quantity && isAdded
  }

  // Hàm chọn call staff reasons
  const onSelectedItem = (value) => {
    if (selectedItems.includes(value)) {
      const newListItems = selectedItems.filter((listItem) => listItem !== value)
      return onSetSelectedItem([...newListItems])
    }
    onSetSelectedItem([...selectedItems, value])
  }

  // Hàm tính toán tăng giảm call staff
  const handleChangeQuantity = ({ isAdded, item }) => {
    if (!selectedItems) return
    const index = selectedItems.findIndex((e) => e.id === item.id)

    if (quantity === DEFAULT_QUANTITY && !isAdded) {
      onSelectedItem(item)
      return
    }
    const isError = checkError(isAdded, item.max_quantity)
    if (isError) return

    const newQuantity = isAdded ? quantity + 1 : quantity - 1
    selectedItems[index].call_staff_option_quantity = newQuantity
    setQuantity(newQuantity)
  }

  // Hàm show nút tăng giảm quantity
  const renderBtnQuantityControl = (item) => {
    return (
      <Box className={cx('btn_group_quantity')}>
        <Box className={cx('btn_quantity')}>
          <Button onClick={() => handleChangeQuantity({ isAdded: false, item })}>
            <SubtractIcon size="24px" color={currentThemeObject.colorText1} />
          </Button>
        </Box>
        <Box className={cx('label_quantity')} color={currentThemeObject.colorText1}>
          {quantity}
        </Box>
        <Box className={cx('btn_quantity')}>
          <Button onClick={() => handleChangeQuantity({ isAdded: true, item })}>
            <PlusIcon
              size="24px"
              color={currentThemeObject.colorText1}
              opacity={quantity < item?.max_quantity ? 1 : 0.3}
            />
          </Button>
        </Box>
      </Box>
    )
  }

  return (
    <Box paddingBottom={'12px'} display="flex" flexDirection={isTablet ? 'column' : 'row'}>
      <Box
        component="button"
        onClick={() => onSelectedItem(itemCallStaff)}
        className={cx('container')}
        bgcolor={'baseColor.colorText5'}
        border={`1.5px solid ${currentThemeObject.color2}`}
        sx={{ opacity: checkItem(itemCallStaff) ? 0.5 : 1 }}>
        <Box
          component="img"
          width="24px"
          height="24px"
          alt="call staff"
          src={getColorIconCallStaff(itemCallStaff.icon_url)}
        />
        <Typography color={onGetColorTitle} className={cx('title_item')}>
          {itemCallStaff.name}
        </Typography>
      </Box>
      {checkItem(itemCallStaff) ? renderBtnQuantityControl(itemCallStaff) : null}
    </Box>
  )
}

CallStaffItem.propTypes = {
  onSetSelectedItem: PropTypes.func,
  itemCallStaff: PropTypes.object,
  selectedItems: PropTypes.array,
}
